<template>
  <div class="totalizadores-scroll-x">
    <SGPRowComponent>
      <SGPColComponent cols="2">
        <SGPBoxHeaderInfoComponent cor="vermelho" larguraMaxima="100%" style="margin-right:8px;min-height: 100%;"
          class="sombra" v-if="totalBox" :value="'total'">
          <template v-slot:topCenter>
            <div class="text-center">
              <span class="h3">
                {{ totalBox.qtd_total }}
              </span>
              <span class="ml-4 h4">TOTAL</span>
            </div>
          </template>

          <template v-slot:contentLeft>
            <span class="d-block font-size-16" style="text-align:center">
              {{ totalBox.qtd_interrompidas }}
            </span>
            <span class="box-sla-interromp" style="text-align:center;display:block">Agendamentos</span>
          </template>
          <template v-slot:contentRight>
            <div class="text-right">
              <span class="d-block font-size-16" style="text-align:center">
                {{ totalBox.percentual_fora_sla }}%
              </span>
              <span class="box-sla-interromp" style="text-align:center;display:block">Fora SLA</span>
            </div>
          </template>
        </SGPBoxHeaderInfoComponent>
      </SGPColComponent>

      <SGPColComponent class="totalizadores-col" cols="2" v-for="macroprocesso in cardsVisiveis" :key="macroprocesso.ctrl_processo_id">
        <SGPBoxHeaderInfoComponent cor="branco" larguraMaxima="100%" :name="macroprocesso.macro_processo"
          :value="macroprocesso" :active="selectedBoxId === macroprocesso.ctrl_processo_id"
          @emitBoxClick="transmitirEmitBoxClick" class="main-box">

          <template v-slot:topLeft>
            <div class="text-left">
              <span class="d-block font-size-14">{{ macroprocesso.qtd_interrompidas }}</span>
              <span class="box-sla-interromp">Agendamento</span>
            </div>
          </template>

          <template v-slot:topCenter>
            <div class="text-center">
              <span class="h1 main-title-pendente">{{ macroprocesso.total }}</span>
            </div>
          </template>

          <template v-slot:topRight>
            <div class="text-right">
              <span class="d-block font-size-14">{{ macroprocesso.percentual_fora_sla }}%</span>
              <span class="box-sla-interromp">Fora SLA</span>
            </div>
          </template>

          <template v-slot:contentCenter>
            <div class="text-center ">
              <span class="main-title">{{ macroprocesso.macro_processo | filterThreeDots }}</span>
            </div>
          </template>
        </SGPBoxHeaderInfoComponent>
      </SGPColComponent>
    </SGPRowComponent>
  </div>
</template>

<style scoped>
.totalizadores-scroll-x {
  overflow-x: auto;
  overflow-y: hidden;
}

.totalizadores-scroll-x>* {
  display: flex;
  flex-wrap: nowrap;
}

.totalizadores-col ::v-deep .box-info-container.branco,
.totalizadores-col ::v-deep .box-info-container.branco span {
  color: #212020;
}

.totalizadores-col ::v-deep .box-info-container.branco.active .top-center,
.totalizadores-col ::v-deep .box-info-container.branco.active .content-center,
.totalizadores-col ::v-deep .box-info-container.branco.active .top-center span,
.totalizadores-col ::v-deep .box-info-container.branco.active .content-center span {
  color: #df323b;
}
</style>

<script>
export default {
  name: "TotalizadoresComponent",

  props: {
    listaTarefasMacroprocessos: {
      type: Object,
      required: false,
      default: () => ({})
    },
    selectedBoxId: {
      type: [Number, String],
      default: null
    }
  },

  computed: {
    totalBox() {
      const geral = Array.isArray(this.listaTarefasMacroprocessos?.estatisticasGerais)
        ? this.listaTarefasMacroprocessos.estatisticasGerais[0]
        : this.listaTarefasMacroprocessos?.estatisticasGerais

      if (!geral) return null

      const total = Number(geral.total_tarefas || 0)
      const interrompidas = Number(geral.interrompidas || 0)
      const foraSla = Number(geral.fora_sla || 0)
      const percentualForaSla = total > 0 ? Math.round((foraSla / total) * 100) : 0

      return {
        qtd_total: total,
        qtd_interrompidas: interrompidas,
        percentual_fora_sla: percentualForaSla
      }
    },

    cards() {
      const estatisticas = Array.isArray(this.listaTarefasMacroprocessos?.estatisticas)
        ? this.listaTarefasMacroprocessos.estatisticas
        : []

      return estatisticas.map(item => ({
        ctrl_processo_id: item.ctrl_processo_id,
        ctrl_macro_processo_id: item.ctrl_processo_id,
        macro_processo: item.processo,
        qtd_interrompidas: item.interrompidas,
        total: item.total_tarefas,
        percentual_fora_sla: item.percentual_fora_sla,
      }))
    },

    cardsVisiveis() {
      return this.cards
    },
  },

  methods: {
    transmitirEmitBoxClick(valor) {
      this.$emit('emitBoxClick', valor)
    }
  }
}
</script>